import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  forwardRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

export const FILE_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FileInputComponent),
  multi: true,
};

@Component({
  selector: 'app-file-input',
  templateUrl: 'file-input.html',
  providers: [FILE_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class FileInputComponent implements OnInit, ControlValueAccessor {
  @Input() disabled = false;

  @Input() required = false;

  @Input() enableUploadAction = false;

  @Input() disableUploadAction = false;

  @Input() fileName: string;

  @Input() placeholder = 'Select or Drop files';

  @Output() fileChange: EventEmitter<File> = new EventEmitter();

  @Output() uploadChange: EventEmitter<File> = new EventEmitter();

  file: any;

  fileInputControl: FormControl;

  fileInputControlPrivate: FormControl;

  constructor() {
    this.fileInputControl = new FormControl();
    this.fileInputControlPrivate = new FormControl();
  }

  ngOnInit() {
    if (this.disabled) {
      this.fileInputControl.disable();
    }
  }

  writeValue(value: any) {
    this.fileInputControl.setValue(value);
    if (!value) {
      this.file = null;
      this.fileName = null;
      this.clear();
    }
  }

  /**
   * Method executed when a file is selected.
   */
  handleSelect(file: File): void {
    if (!this.disabled) {
      const name = file ? file.name : null;
      this.fileInputControl.setValue(name);
      this.file = file;
      this.fileName = file.name;
      this.fileChange.emit(this.file);
      this.onChange(name);
    }
  }

  clear() {
    this.file = null;
    this.fileName = null;
    this.fileInputControl.setValue('');
    this.fileInputControlPrivate.setValue('');
    this.fileChange.emit(null);
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
    const action = disabled ? 'disable' : 'enable';
    this.fileInputControl[action]();
    this.fileInputControlPrivate[action]();
  }

  public onUpload() {
    this.uploadChange.emit(this.file);
  }

  onChange: (value: any) => void = (value) => {
    /**/
  };

  registerOnChange(fn: (value: any) => void) {
    this.onChange = fn;
  }

  onTouched: () => any = () => {
    /**/
  };

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}
